import { AMOUNT_KZT_KEY } from '@esentai/core/features/salesTurnovers/consts/keys';
import { annotations } from '@esentai/core/features/salesTurnovers/serializer';
import { descending } from '@esentai/core/query-dsl';
import { sort } from '@esentai/core/serializers/params';

import { createPageSerializer } from '@/serializers';

export default createPageSerializer({
  ...annotations,

  sort: sort({
    defaultValue: descending(AMOUNT_KZT_KEY),
  }),
});
